import { getSha256 } from '../../../utilities'

export const hashAnswer1 = async (answer1: string): Promise<string> => {
  const strippedAnswer1 = answer1.trim().toLowerCase()

  const hashInput = `${strippedAnswer1}`
  const hashedAnswers = await getSha256(hashInput)

  return hashedAnswers.toString()
}

export const hashAnswer2 = async (answer2: string): Promise<string> => {
  const strippedAnswer2 = answer2.trim().toLowerCase()

  const hashInput = `${strippedAnswer2}`
  const hashedAnswers = await getSha256(hashInput)

  return hashedAnswers.toString()
}
